import React, { useEffect, useState } from 'react';
import { useParams} from 'react-router-dom';
import ChartDashboardViewr from './ChartDashboardViewr';

import { API_BASE_URL, fetchData } from './Common';

function Project() {
  const { projectId, dashboardId, sharecode } = useParams();
  const [tableColumnData, setTableColumnData] = useState([]);
  const [isTableColumnDataLoaded, setIsTableColumnDataLoaded] = useState(false);
  const [dashboards, setDashboards] = useState([]);
  const [isDashboardsLoaded, setIsDashboardsLoaded] = useState(false);
  const [widgets, setWidgets] = useState([]);
  const [isWidgetsLoaded, setIsWidgetsLoaded] = useState(false);
  const [tables, setTables] = useState([]);
  const [isTablesLoaded, setIsTablesLoaded] = useState(false);

  useEffect(() => {

    fetchData(`${API_BASE_URL}/tables/${projectId}`, setTables, setIsTablesLoaded, 'tables', sharecode);

    fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData', sharecode);///////////falta dashboardId

    fetchData(`${API_BASE_URL}/widgets/${projectId}`, setWidgets, setIsWidgetsLoaded, 'widgetData', sharecode, dashboardId);

    fetchData(`${API_BASE_URL}/dashboards/${projectId}`, setDashboards, setIsDashboardsLoaded, 'dashboardData', sharecode, dashboardId);

  }, [dashboardId, projectId, sharecode]);

  return (
<div className="home-container" style={{padding: '0px 20px 0px 20px',}}>

{isTablesLoaded && isTableColumnDataLoaded && isWidgetsLoaded && isDashboardsLoaded && (
  <>
  <p className="text1">{dashboards[dashboardId].name}</p>

      <ChartDashboardViewr
        widgets={widgets}
        permission={"URL"}
        dashboard={dashboards[dashboardId]}
        tableColumnData={tableColumnData}
        tables={tables}
      />
  </>
)}
</div>
);

}

export default Project;
